<div class="expense-report-container">
  <div class="table-heading">Expense Report</div>

  <app-filter-panel
    [filterProps]="filterProps"
    [filters]="filters"
    (filtersChanged)="onFilterChange($event)">
  </app-filter-panel>

  <app-table
    *ngIf="data$ | async as expenseReportTableData"
    [columns]="columns"
    [tableData]="expenseReportTableData"
    (pageChange)="onPageChangeExpenseReport($event)"
    (sortChange)="onSortChangeExpenseReport($event)"
    (cellClick)="handleCellClick($event)">
  </app-table>
</div>
